import { Injectable } from '@angular/core';

import { first, map, Observable, of, Subject, Subscription } from 'rxjs';
import { IToast } from '../models/interfaces.models';
import { CustomSpecificInfo } from '../core/shared/CustomSpecificInfo';
import { AbcConfigService } from '@barthauer/abc/core/configuration';
import { DataService } from './data.service';
import { DataService as CoreDataService, Query, QueryColumn, QueryObjectsModel} from '@barthauer/abc/core/data'; 
import { _AbcGridComponent, AbcPopupComponent } from '@barthauer/abc/ui-components';
import { ObjectKeys } from '@barthauer/custom/iddat';
import { ItemsArray } from '../models/organizational-structure.model';
import { Address } from '@barthauer/custom/xmt-models';
import { ToastType } from '../models/enumeration-list.model';
@Injectable({
  providedIn: 'root',
})
export class AppService {
  private customSpecificInfo: CustomSpecificInfo;
  private notificationSubject: Subject<IToast> = new Subject();
  public notification$: Observable<IToast> = this.notificationSubject.asObservable();

  private gridDataSubject = new Subject<any>();
  public updateGridData$ = this.gridDataSubject.asObservable();

  constructor(
    private configService: AbcConfigService,
    private dataService : DataService,
    private coreDataService: CoreDataService
  ) { 
    const currentConfiguration = configService.getConfiguration();
    this.customSpecificInfo = currentConfiguration.CustomSpecificInfo;
  }
  public getCustomSpecificInfo(): CustomSpecificInfo {
    return this.customSpecificInfo;
  }

  public callNotification(notification: IToast): void {
    this.notificationSubject.next(notification);
  }

  public updateGridData(data: any) {
    this.gridDataSubject.next(data);
  }

  public openDeleteDialog(popup: AbcPopupComponent, type: ObjectKeys,id?: string) : Observable<boolean> {
        if([ObjectKeys.AUDIT, ObjectKeys.ADDRESS, ObjectKeys.BIBMEAUSRE, ObjectKeys.Person].includes(type)){
            popup.instance.show();
        }else {
            return this.readAuditItemSelectedById(id,type).pipe(
                first(),
                map((data) => {
                    popup.instance.show();
                    return data.length > 0;
                })
            );
        }
        return of(false);
    }

    public readAuditItemSelectedById(id:string, type : ObjectKeys): Observable<any> {
        const opathByType : Map<string,string> = new Map([
            [ObjectKeys.BIBCATEGORY,"IdRefBibCategory"],
            [ObjectKeys.BIBQUESTION,"IdRefBibQuestion"],
            [ObjectKeys.LIBRARY,"IdRefLibrary"],
            [ObjectKeys.BIBRESPONSE,"IdRefBibResponse"]
        ])
        const auditItemSelectedQuery: Query = new Query();
        const auditItemSelectedQueryColumns: Array<QueryColumn> = [this.coreDataService.createQueryColumn('Id', 'Id')];
        auditItemSelectedQuery.OPath = `${opathByType.get(type)}='${id}'`;
        auditItemSelectedQuery.ObjectType = type===ObjectKeys.LIBRARY ? ObjectKeys.AUDIT : ObjectKeys.AUDITITEM;
        auditItemSelectedQuery.Columns = auditItemSelectedQueryColumns;
        const auditItemSelectedQueryDocument: QueryObjectsModel = new QueryObjectsModel();
        auditItemSelectedQueryDocument.ObjectQueries = [auditItemSelectedQuery];

        return this.coreDataService.executeReadObjectsQuery(auditItemSelectedQueryDocument);
    }

    public deleteItem(
        popup: AbcPopupComponent,
        subscriptions: Subscription[],
        type : ObjectKeys,
        selectedItemId:string,
        items:ItemsArray,
        notificationMessage: string,
        clonedItems?: Address[]): void {
        subscriptions.push(
            this.dataService.deleteObject(type, selectedItemId).pipe(first()).subscribe(
                (deletedItem) => {
                    if (deletedItem?.Id) {
                        items.splice(items.findIndex(item => item.Id === deletedItem?.Id),1);
                        type===ObjectKeys.ADDRESS ? clonedItems.splice(clonedItems.findIndex(item => item.Id === deletedItem?.Id),1):null;
                        this.callNotification({
                            message: notificationMessage,
                            type: ToastType.SUCCESS,
                        });
                    }else {
                        this.callNotification({
                            message: this.dataService.res('Dt-Notification-Error'),
                            type: ToastType.ERROR,
                        });
                    }
                },
                (error) => {
                    this.callNotification({
                    message: this.dataService.res('Dt-Notification-Error'),
                    type: ToastType.ERROR,
                    });
                }
            )
        );
        popup.instance.hide();
    }
    public applyFilter(isFilterApplied: boolean, grid: _AbcGridComponent,itemName: string): boolean {
        if(isFilterApplied) return isFilterApplied;
        const item = localStorage.getItem(itemName);
        if (item) {
            grid.instance.columnOption('Designation', 'filterValue', item);
            localStorage.setItem(itemName,'');
        } else {
            grid.instance.clearFilter();
        }
        return true;
    }
}
